// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import {
  AnimatedView,
  StatsTable,
}           from '../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../services/fetchTools';
import {Link} from 'react-router-dom';
import { withRouter } from 'react-router';
import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import {List, ListItem} from 'material-ui/List';
import Divider from 'material-ui/Divider';
import {GridList, GridTile} from 'material-ui/GridList';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import RaisedButton from 'material-ui/RaisedButton';
import Popover from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';

import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton';
import FontIcon from 'material-ui/FontIcon';
import NavigationExpandMoreIcon from 'material-ui/svg-icons/navigation/expand-more';
import DropDownMenu from 'material-ui/DropDownMenu';
import {Toolbar, ToolbarGroup, ToolbarSeparator, ToolbarTitle} from 'material-ui/Toolbar';

class PartnerNotification extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      tickets: '',
      data_uploaded: false,
      data_error: false,
      value: 3,
      status: 1,
    };
  }

  componentWillMount() {
    console.log("componentWillMount:Notifications");
    console.log(this.props);
    const { actions: { enterPage } } = this.props;
    enterPage('Notifications');
  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('Notifications');
  }

  componentDidMount() {
    this.getTicketList();
  }

  getTicketList() {
     const url = `${getLocationOrigin()}/eagleeye/get_tickets_list/`;
     const options = {...defaultOptions};

     fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ tickets: data.tickets}))
       .catch(error => error);
  }

  handleChange = (event, index, value) => this.setState({value});
  handleChangeStatus = (event, index, value) => this.setState({'status':value});


  render() {
    console.log("Notifications");
    console.log(this.state);
    console.log(this.props);
    const {
      statsTable
    } = this.props;

    const {
      actions: {
        fetchStatsTableDataIfNeeded,
        }
      } = this.props;    
    return(
      <div>
      <div className="row">
          <StatsTable name="customer_feedback_queries" displayName="Customer Feedback/Queries Football" bigTable={true} data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
        </div>
      <div className="row">
          <StatsTable name="customer_feedback_queries_badminton" displayName="Customer Feedback/Queries Badminton" bigTable={true} data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
        </div>
      <div className="row">
          <StatsTable name="support_tickets_app" displayName="Support Tickets" bigTable={true} data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
        </div>    
      </div>
    );
  }
}

export default PartnerNotification;



// WEBPACK FOOTER //
// ./src/app/views/partner/partnerNotification/PartnerNotification.js